// extracted by mini-css-extract-plugin
module.exports = {"section":"SearchBar_section__3qF8L","contentWrap":"SearchBar_contentWrap__h4lA5"};